import React from 'react';
import PropTypes from 'prop-types';

import Group from '../../../../components/Group';
import RatePresenter, {
  RATES_TYPE,
} from '../../../../presenters/RatePresenter';

import RateList from './components/RateList';

const RateLists = (props) => {
  const { defaultRates, birthdayRates } = props;

  return (
    <Group title="Cashback Rates" className="rates-group">
      <div className="tables-group">
        <RateList rates={defaultRates} rateType={RATES_TYPE.default} />
        <RateList rates={birthdayRates} rateType={RATES_TYPE.birthday} />
      </div>
    </Group>
  );
};

export default RateLists;

RateLists.propTypes = {
  defaultRates: PropTypes.arrayOf(RatePresenter.shape()).isRequired,
  birthdayRates: PropTypes.arrayOf(RatePresenter.shape()),
};

RateLists.defaultProps = {
  birthdayRates: [],
};
